package org.lennycodes.hldi.data

import kotlinx.serialization.Serializable

@Serializable
data class Admin(
    val uid: String,
    val fullName: String,
    val email: String
)
@Serializable
data class Program(
    val id: String,
    val title: String,
    val description: String,
    val icon: String,
    val color: String
)
@Serializable
data class Milestone(
    val id: String,
    val year: String,
    val description: String
)

data class Project(
    val id: String,
    val title: String,
    val location: String,
    val description: String,
    val imageUrl: String,
    val impact: String,
    val metrics: Map<String, Int>
)
@Serializable
data class BlogPost(
    val id: String,
    val title: String,
    val content: String,
    val author: String,
    val date: String,
    val category: String,
    val imageUrl: String
){
    fun toFirebaseData(): dynamic {

        val data = js("{}")

        data.id = id
        data.title = title
        data.content = content
        data.author = author
        data.date = date
        data.category = category
        data.imageUrl = imageUrl
        return data
    }
}
@Serializable
data class Event(
    val id: String,
    val title: String,
    val date: String,
    val location: String,
    val description: String,
    val registrationUrl: String
)

data class TeamMember(
    val id: String,
    val name: String,
    val role: String,
    val bio: String,
    val imageUrl: String,
    val department: String,
    val facebook: String = "",
    val instagram: String = "",
    val email: String = "",
    val isLeadership: Boolean = false,
    val isVolunteer: Boolean = false
)
@Serializable
data class UploadedImage(
    val url: String,
    val storagePath: String
)
@Serializable
data class GalleryImage(
    val id: String = "",
    val url: String = "",
    val title: String = "",
    val category: String = "",
    val storagePath: String = ""
) {

    fun toFirebaseData(): dynamic {

        val data = js("{}")

        data.id = id
        data.url = url
        data.title = title
        data.category = category
        data.storagePath = storagePath
        return data
    }
}
 data class MissionBlock(
     val icon: String,
     val title: String,
     val description: String
 )
data class TimelineMilestone(
    val year: String,
    val event: String
)
@Serializable
data class ResourceDocument(
    val id: String,
    val title: String,
    val category: String,
    val description: String,
    val fileUrl: String,
    val publishedOn: String,
    val storagePath: String = ""

){
    fun toFirebaseData(): dynamic {
        val data = js("{}")
        data.id = id
        data.title = title
        data.category = category
        data.description = description
        data.fileUrl = fileUrl
        data.publishedOn = publishedOn
        data.storagePath = storagePath
        return data
    }
}